var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TablePageContainer',{attrs:{"config":_vm.config,"data":_vm.data,"isLoading":_vm.isLoading,"sortState":_vm.sortState,"title":_vm.title,"updateSort":_vm.updateSort,"onRowClick":_vm.handleOnRowClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }